import Vue from 'vue';
var hub = new Vue();
export const eventHub = hub;